// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3FX3hNmMzONBHK {\n  font-size: 12px;\n  line-height: 14px;\n  margin: 0 0 6px;\n  min-width: 105px;\n  color: #6B778C;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"notificationDate": "_3FX3hNmMzONBHK"
};
export default ___CSS_LOADER_EXPORT___;
